import api from "src/apis/api"

export async function fetchTags({ q = "" } = {}) {
  const params = new URLSearchParams()
  if (q) params.set("q", q)
  const { data } = await api.get(`/api/v1/tags?${params}`)
  return data
}

export async function createTag(payload) {
  const { data } = await api.post("/api/v1/tags", { tag: payload })
  return data
}

export async function updateTag(id, payload) {
  const { data } = await api.patch(`/api/v1/tags/${id}`, { tag: payload })
  return data
}

export async function deleteTag(id) {
  const { data } = await api.delete(`/api/v1/tags/${id}`)
  return data
}

export async function addTagging({ tag_id, taggable_type, taggable_id }) {
  const { data } = await api.post("/api/v1/taggings", { tag_id, taggable_type, taggable_id })
  return data
}

export async function removeTagging({ tag_id, taggable_type, taggable_id }) {
  const { data } = await api.delete("/api/v1/taggings", {
    data: { tag_id, taggable_type, taggable_id },
  })
  return data
}
